export default __webpack_public_path__ + "static/outbrain-0fa6e5ebdec37810539eb1559ec87927.svg";